import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import ModalActions from 'Modules/Modals/actions';
import { EnumTheme, ModalType, EnumButtonSize } from 'constants/enums';
import ThemeButton from 'Components/ThemedButton';

export const AUTH_BTN_TEST_ID = 'AUTH_BTN_TEST_ID';

const Button = styled(ThemeButton).attrs({
  use: EnumTheme.roundWhite,
  size: EnumButtonSize.small,
  testId: AUTH_BTN_TEST_ID,
})`
  font-size: 11px;
  line-height: 18px;
`;

const TempUserButton: React.FC = () => {
  const dispatch = useDispatch();
  const openAuthModal = () => dispatch(ModalActions.openModal(ModalType.Auth));

  return <Button onClick={openAuthModal}>Войти</Button>;
};

export default TempUserButton;
